import { render, staticRenderFns } from "./EventIcon.vue?vue&type=template&id=2cc8b946&scoped=true"
import script from "./EventIcon.vue?vue&type=script&lang=ts"
export * from "./EventIcon.vue?vue&type=script&lang=ts"
import style0 from "./EventIcon.vue?vue&type=style&index=0&id=2cc8b946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8b946",
  null
  
)

export default component.exports